/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import config from "/public/config";

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },

  async loadSideTopImage({ commit, state, dispatch }) {
    // localStorage에서만 이미지를 로드 (API 호출 제거)
    // 로그인 시에만 API 호출하여 업데이트됨
    if (localStorage.getItem(`${config.HOST_NAME}_side_top_image`)) {
      const cachedImage = localStorage.getItem(`${config.HOST_NAME}_side_top_image`);
      commit('SET_SIDE_TOP_IMAGE', cachedImage);
      commit('SET_IS_LOADED_SIDE_TOP_IMAGE', true);
    }

    // API 호출 제거 - 로그인 페이지에서만 업데이트됨
    // const configValue = await dispatch("keyValue/LOAD_CONFIG", {
    //   key: "side_top_image",
    // });

    // if (configValue.path) {
    //   localStorage.setItem(`${config.HOST_NAME}_side_top_image`, configValue.path);
    //   commit('SET_SIDE_TOP_IMAGE', configValue.path);
    //   commit('SET_IS_LOADED_SIDE_TOP_IMAGE', true);
    // }
  },
  async loadSideTopImageStyle({ commit, state, dispatch }) {
    const storageKey = `${config.HOST_NAME}_side_top_image_style`;
    // localStorage에서만 스타일을 로드 (API 호출 제거)
    // 로그인 시에만 API 호출하여 업데이트됨
    if (localStorage.getItem(storageKey)) {
      const cachedStyle = localStorage.getItem(storageKey);
      try {
        commit('SET_SIDE_TOP_IMAGE_STYLE', JSON.parse(cachedStyle));
        commit('SET_IS_LOADED_SIDE_TOP_IMAGE_STYLE', true);
      } catch (e) {
        console.error('사이드 상단 이미지 스타일 파싱 중 오류:', e);
      }
    }

    // API 호출 제거 - 로그인 페이지에서만 업데이트됨
    // const configValue = await dispatch("keyValue/LOAD_CONFIG", {
    //   key: "side_top_image_style",
    // });

    // localStorage.setItem(storageKey, JSON.stringify(configValue));
    // commit('SET_SIDE_TOP_IMAGE_STYLE', configValue);
    // commit('SET_IS_LOADED_SIDE_TOP_IMAGE_STYLE', true);
  },
}

export default actions
